/**
 * Pure decision logic for the durable edit buffer (ADR-033, git-native editing).
 * Kept out of `editBufferService` so it is unit-testable without IndexedDB —
 * the store is thin, the decisions live here.
 */
import type { EditBuffer } from '@/services/editBufferService';

/** Stable key for a document's buffer: repo + path + branch ('' = default). */
export function editBufferKey(repoFullName: string, path: string, branch: string): string {
  return `${repoFullName}::${path}::${branch || ''}`;
}

/**
 * Whether a buffered edit is worth offering to restore. Only when it holds
 * content that actually differs from what git returned — a buffer equal to the
 * loaded file is a committed-and-synced leftover, not unsaved work, and offering
 * to "restore" it would be noise. A missing buffer is never restorable.
 */
export function isRestorable(buffer: EditBuffer | null, loadedContent: string): boolean {
  return !!buffer && buffer.content !== loadedContent;
}
